import { render, staticRenderFns } from "./speakers-row.vue?vue&type=template&id=5601a52a&scoped=true&"
import script from "./speakers-row.vue?vue&type=script&lang=js&"
export * from "./speakers-row.vue?vue&type=script&lang=js&"
import style0 from "./speakers-row.vue?vue&type=style&index=0&id=5601a52a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5601a52a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/inspireyourtribe.salamander.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5601a52a')) {
      api.createRecord('5601a52a', component.options)
    } else {
      api.reload('5601a52a', component.options)
    }
    module.hot.accept("./speakers-row.vue?vue&type=template&id=5601a52a&scoped=true&", function () {
      api.rerender('5601a52a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/pageParts/speakers-row.vue"
export default component.exports